export const LOG_IN_PAGE = 'log-in';
